import { useParams } from 'react-router-dom';
import { ContractProcedureStep, useContractProcedure } from './hooks';
import { LoadingContainer } from 'views/mutual/loading';
import { LeaseFundContractConfirm } from './contractConfirm';
import { ContractDocumentCheck } from './contractDocumentCheck';
import { LeaseFundContractComplete } from './contractComplete';
import { useEffect } from 'react';
import { NotFoundData, NotFoundDataBackPageType } from 'views/mutual/notFoundData';
import { ContractCanceled } from './contractCanceled';
import { useGlobalToastHandler } from 'views/mutual/globalToast/hooks';

interface StepProps {
  applicationID?: string;
  defaultContractProcedureStep?: ContractProcedureStep;
}

// 契約手続きはメールのリンクURLから遷移する IDはURLに埋め込まれている
export const LeaseFundContractProcedure: React.FC<StepProps> = ({ applicationID, defaultContractProcedureStep }) => {
  const { id } = useParams<{ id: string }>();
  const props = useContractProcedure({ id: applicationID ? applicationID : id!, defaultContractProcedureStep });
  const { showError } = useGlobalToastHandler();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.contractProcedureStep]);

  if (props.contractInfo.fetching) {
    return (
      <LoadingContainer isLoading={props.contractInfo.fetching}>
        <div></div>
      </LoadingContainer>
    );
  } else {
    if (!props.contractInfo.data?.GetContractInfo?.Details) {
      if(props.contractInfo.data?.GetContractInfo?.Message != null){
        showError(props.contractInfo.data?.GetContractInfo?.Message)
      }
      return (
        <NotFoundData
          backPageType={{
            kind: 'home',
          }}
        />
      );
    }

    switch (props.contractProcedureStep) {
      // case ContractProcedureStep.DocumentCheck:
      //   return <ContractDocumentCheck {...props} />;
      case ContractProcedureStep.Confirm:
        return (
          <LeaseFundContractConfirm
            contractInfo={props.contractInfo.data?.GetContractInfo?.Details!}
            onNext={props.onNext}
            onBack={props.onBack}
            setCheckedAssignmentAgreementDocument={props.setCheckedAssignmentAgreementDocument}
            setCheckedContractAgreementDocument={props.setCheckedContractAgreementDocument}
            setOpenedContractAgreementDocument={props.setOpenedContractAgreementDocument}
            checkedAssignmentAgreementDocument={props.checkedAssignmentAgreementDocument}
            checkedContractAgreementDocument={props.checkedContractAgreementDocument}
            openedContractAgreementDocument={props.openedContractAgreementDocument}
          />
        );
      case ContractProcedureStep.Complete:
        return (
          <LeaseFundContractComplete
            contractInfo={props.contractInfo.data?.GetContractInfo?.Details!}
            contractAgreementDocumentDownload={props.contractAgreementDocumentDownload}
          />
        );
      case ContractProcedureStep.Canceled:
        return <ContractCanceled />;
    }
  }
};
